var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSquare63DError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 80 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M29 48.5a1.5 1.5 0 0 0 1.5 1.5h19a1.5 1.5 0 0 0 1.5-1.5v-19a1.5 1.5 0 0 0-1.5-1.5h-19a1.5 1.5 0 0 0-1.5 1.5v19Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M17.5 39.5A2.5 2.5 0 0 1 20 42v11.5a2.5 2.5 0 0 1-2.5 2.5h-10A2.5 2.5 0 0 1 5 53.5v-14h12.5ZM17.5 22a2.5 2.5 0 0 1 2.5 2.5V36a2.5 2.5 0 0 1-2.5 2.5H5v-14A2.5 2.5 0 0 1 7.5 22h10ZM37 17.5a2.5 2.5 0 0 1-2.5 2.5h-11a2.5 2.5 0 0 1-2.5-2.5v-10A2.5 2.5 0 0 1 23.5 5h11A2.5 2.5 0 0 1 37 7.5v10Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M37 15V7.5A2.5 2.5 0 0 0 34.5 5h-11A2.5 2.5 0 0 0 21 7.5V15"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M59 17.5a2.5 2.5 0 0 1-2.5 2.5h-11a2.5 2.5 0 0 1-2.5-2.5v-10A2.5 2.5 0 0 1 45.5 5h11A2.5 2.5 0 0 1 59 7.5v10Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M59 15V7.5A2.5 2.5 0 0 0 56.5 5h-11A2.5 2.5 0 0 0 43 7.5V15M15 22H7.5A2.5 2.5 0 0 0 5 24.5v29A2.5 2.5 0 0 0 7.5 56H15"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M62.5 38.5A2.5 2.5 0 0 1 60 36V24.5a2.5 2.5 0 0 1 2.5-2.5h10a2.5 2.5 0 0 1 2.5 2.5v14H62.5ZM62.5 56a2.5 2.5 0 0 1-2.5-2.5V42a2.5 2.5 0 0 1 2.5-2.5H75v14a2.5 2.5 0 0 1-2.5 2.5h-10Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M65 56h7.5a2.5 2.5 0 0 0 2.5-2.5v-29a2.5 2.5 0 0 0-2.5-2.5H65"
})));
SvgSquare63DError.viewBox = '0 0 80 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgSquare63DError);
export default ForwardRef;